
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2021 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import { logging } from "dc-core";

const logger = logging.getLogger("dc-rendition-provider");

// Fetching the value of meta tag to check if LPM is enabled
let isAdobeNetworkUser = false;
const adobeExternal = "adobe_external";
const metaTag = document.querySelectorAll(`meta[name^=${adobeExternal}]`);
if (metaTag) {
    if (metaTag[0] && metaTag[0].content) {
        isAdobeNetworkUser = false;
    } else {
        isAdobeNetworkUser = true;
    }
}

let documentId = "";
let commonFields = {
    sessionId: window.dcWebSessionId,
    userAgent: navigator.userAgent,
    isAdobeNetworkUser,
};

export function setDocumentId(documentid) {
    documentId = documentid;
}

export function addFieldsToCommonLogging(newFields) {
    commonFields = { ...commonFields, ...newFields };
}

export const logEvent = (eventName, payload) => {
    logger.emit(eventName, {
        ...payload,
        ...commonFields,
        docSessionId: window.docSessionId,
        documentId,
    });
};
